import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { actionCreators } from '../actions/globalAction';
import { StatCard } from '../components/solar/StatCard';
import { ChartCardWithPagination } from '../components/solar/ChartCardWithPagination';
import { getOptions } from '../components/options/evu_pv';
import { data, data2 } from '../components/data/evu_pv';
import { evu_pv } from '../components/objects/evu_pv';
import { Line } from 'react-chartjs-2';
import { Card } from 'react-bootstrap';

class Evu_pvClass extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        const nextYear = parseInt(nextProps.match.params.Year) || 0;
        if (prevState.prevYear !== nextYear) {
            return { prevYear: nextYear, _fetchNeeded: true };
        }
        return null;
    }

    _fetchData(yearValue) {
        const Year = parseInt(yearValue) || 0;

        if (Year > 0) {
            evu_pv.YearStromGesamtEvuPvClass.url = evu_pv.YearStromGesamtEvuPvClass.defaultSegment + "/gesamtjahrshort/" + Year;
        }
        else {
            evu_pv.YearStromGesamtEvuPvClass.url = evu_pv.YearStromGesamtEvuPvClass.defaultSegment + "/gesamtjahrshort/" + new Date().getFullYear();
        }

        evu_pv.YearStromGesamtEvuPvClass.forceRefresh = true;
        this.props.request(evu_pv["YearStromGesamtEvuPvClass"]);
    }

    componentDidMount() {
        const initYear = parseInt(this.props.match.params.Year) || 0;
        this.setState({ prevYear: initYear }, () => {
            this._fetchData(this.props.match.params.Year);
        });
    }

    componentDidUpdate() {
        if (this.state._fetchNeeded) {
            this.setState({ _fetchNeeded: false }, () => {
                const nextYear = parseInt(this.props.match.params.Year) || 0;
                this._fetchData(nextYear);
            });
        }
    }

    state = {};

    render() {
        return (
            <div>
                {renderUIKPIRow(this.props)}
                {renderUIGesamt(this.props)}
            </div>
        );
    }
}

function renderUIKPIRow(props) {
    let BarYearStromGesamtEVUPVUI = props.BarYearStromGesamtEVUPVUI || {};

    // BOTH isLoaded=true UND Daten vorhanden — nicht nur auf die Flag verlassen!
    let hasData = typeof (BarYearStromGesamtEVUPVUI.monat) !== 'undefined' && BarYearStromGesamtEVUPVUI.monat.length > 0;
    let loading = !props.isLoaded || !hasData;

    // KPI-Berechnungen aus API-Daten (nur wenn Daten wirklich da sind)
    let gesamtSumme = 0;
    let bezugSumme = 0;

    if (hasData && typeof (BarYearStromGesamtEVUPVUI.gesamt) !== 'undefined') {
        for (var i = 0; i < BarYearStromGesamtEVUPVUI.gesamt.length; i++) {
            gesamtSumme += parseFloat(BarYearStromGesamtEVUPVUI.gesamt[i]) || 0;
            bezugSumme += parseFloat(BarYearStromGesamtEVUPVUI.bezug[i]) || 0;
        }
    }

    const gesamtKWh = (gesamtSumme / 100).toFixed(0);
    const bezugKWh = (bezugSumme / 100).toFixed(0);

    // Hoechster Ertrag-Monat ermitteln
    let hochstMonat = '-';
    let hochstWert = 0;
    if (hasData && typeof (BarYearStromGesamtEVUPVUI.gesamt) !== 'undefined') {
        for (var i = 0; i < BarYearStromGesamtEVUPVUI.gesamt.length; i++) {
            const val = parseFloat(BarYearStromGesamtEVUPVUI.gesamt[i]) || 0;
            if (val > hochstWert) {
                hochstWert = val;
                hochstMonat = BarYearStromGesamtEVUPVUI.monat[i];
            }
        }
    }

    // Differenz: positiv = Ueberschuss, negativ = Defizit
    const saldoKWh = ((gesamtSumme - bezugSumme) / 100).toFixed(0);

    // Jahr aus URL-Parametern oder aktuelles Jahr
    const jahr = parseInt(props.match ? props.match.params.Year : 0) || new Date().getFullYear();

    return (
        <div className="row mb-3">
            <div className="col-12">
                <h5>EVU/PV — Jahresuebersicht {jahr}</h5>
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Gesamtertrag" value={gesamtKWh} unit="kWh" isLoading={loading}
                    description="Jahrgesamt PV-Ertrag in kWh. Alle erzeugten Strommenge der Anlage." />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Gesamtbezug" value={bezugKWh} unit="kWh" isLoading={loading}
                    description="Strom aus dem Netz bezogen. Entsteht bei Nacht, schlechtem Wetter oder hohem Verbrauch." />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Hoechster Ertrag" value={hochstMonat} unit="" isLoading={loading}
                    description="Monat mit dem höchsten PV-Ertrag. In der Regel zwischen Mai und September." />
            </div>
            <div className="col-6 col-md-3">
                <StatCard label="Differenz" value={saldoKWh} unit="kWh" isLoading={loading}
                    description="PV-Ertrag minus Netzbezug. Positiv bedeutet die Anlage erzeugt mehr als bezogen wird." />
            </div>
        </div>
    );
}

function renderUIGesamt(props) {
    let BarYearStromGesamtEVUPVUI = props.BarYearStromGesamtEVUPVUI || {};

    // Loading: BOTH isLoaded=true UND Daten vorhanden. Nicht nur auf die Flag verlassen!
    let hasData = typeof (BarYearStromGesamtEVUPVUI.monat) !== 'undefined' && BarYearStromGesamtEVUPVUI.monat.length > 0;
    let loading = !props.isLoaded || !hasData;

    // default chart data object
    let chartData = { labels: [''], datasets: [{ data: [0] }, { data: [0] }] };

    if (hasData) {
        let labels = [];
        let datagesamt = [];
        let databezug = [];

        for (var i = 0; i < BarYearStromGesamtEVUPVUI.monat.length; i++) {
            labels.push(BarYearStromGesamtEVUPVUI.monat[i]);
            datagesamt.push(BarYearStromGesamtEVUPVUI.gesamt[i]);
            databezug.push(BarYearStromGesamtEVUPVUI.bezug[i]);
        }

        chartData = {
            labels: labels,
            datasets: [
                { ...data.datasets[0], data: datagesamt,
                  label: "Ertrag (" + Math.round((datagesamt.reduce((pv, cv) => pv + cv, 0) / 100) * 100) + " kWh)" },
                { ...data2.datasets[0], data: databezug,
                  label: "Bezug (" + Math.round((databezug.reduce((pv, cv) => pv + cv, 0) / 100) * 100) + " kWh)" }
            ]
        };
    }

    const jahr = parseInt(props.match ? props.match.params.Year : 0) || new Date().getFullYear();

    return (
        <ChartCardWithPagination
            routeSegment={'evu_pv'}
            onlyYear={true}
            match={props.match}
            history={props.history}
            loading={loading}>
            <Card className="chart-card">
                <Card.Header as="h3">Ertrag vs Bezug in {jahr}</Card.Header>
                <Card.Body>
                    <Line data={chartData} options={{ ...getOptions(), animation: false }} />
                </Card.Body>
            </Card>
        </ChartCardWithPagination>
    );
}

export default connect(
    state => state.evupvReducer,
    dispatch => bindActionCreators(actionCreators, dispatch)
)(Evu_pvClass);
